import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useTranslate } from "../context/TranslationContext";
import { useCreateNewsletterMutation } from "../redux/Apis/Newsletter";

const useHomeController = () => {
  const { t } = useTranslate("footer");
  const lang = useSelector((state) => state.language.lang);
  const { isLoggedIn, user } = useSelector((state) => state.authSlice);
  const { general } = useSelector((state) => state.generalSlice);

  const [
    submit,
    {
      data: newsletterData,
      isSuccess,
      isLoading: isNewsletterLoading,
      error: newsletterError,
    },
  ] = useCreateNewsletterMutation();

  const [selected, setSelected] = useState(1);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [email, setEmail] = useState("");
  const [agree, setAgree] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (general?.categories?.length) {
      setSelectedCategory(general.categories[0]._id);
    }
  }, [general?.categories]);

  useEffect(() => {
    if (isSuccess && newsletterData?.message) {
      setEmail("");
      toast.success(newsletterData.message);
    } else if (newsletterError?.data?.message) {
      toast.error(newsletterError.data.message);
    }
  }, [isSuccess, newsletterData, newsletterError]);

  const onSubmitSubscribe = () => {
    if (!email) return setError("Please enter an email address");
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))
      return setError("Please enter a valid email address");
    if (!agree) return setError(t("funnerCheckError"));

    setError("");
    submit({
      body: {
        email,
        tag:
          user?.role === "learner"
            ? "funnel_creator_interest"
            : "funnel_learner_entry",
      },
      params: { lang },
    });
  };

  return {
    values: {
      isLoggedIn,
      user,
      categories: general?.categories || [],
      selected,
      email,
      selectedCategory,
      agree,
      error,
      isNewsletterLoading,
    },
    functions: {
      setSelected,
      setEmail,
      setAgree,
      setError,
      onSubmitSubscribe,
      setSelectedCategory,
    },
  };
};

export default useHomeController;
